export { Color, ColorNames } from './Color'
